<template>
    <div>
        <div>
            <nav class="sm:hidden" :aria-label="$t('Back')">
                <a href="#" class="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700">
                    <ChevronLeftIcon class="flex-shrink-0 -ml-1 mr-1 h-5 w-5 text-gray-400" aria-hidden="true"/>
                    {{ $t('Back') }}
                </a>
            </nav>
            <nav class="hidden sm:flex" :aria-label="$t('Breadcrumb')" v-if="breadcrumbs.length > 0">
                <ol role="list" class="flex items-center space-x-4">
                    <li v-for="(crumb,idx) in breadcrumbs">
                        <div class="flex" :class="{'items-center':idx > 0}">
                            <ChevronRightIcon class="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true" v-if="idx > 0"/>
                            <Link :href="crumb.url" class="text-sm font-medium text-gray-500 hover:text-gray-700" :class="{'ml-4':idx > 0}">{{ $t(crumb.label) }}</Link>
                        </div>
                    </li>
                </ol>
            </nav>
        </div>
        <div class="mt-2 md:flex md:items-center md:justify-between">
            <div class="flex-1 min-w-0">
                <h2 class="mb-3 sm:truncate">
                    <slot name="title">
                    </slot>
                </h2>
            </div>
            <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4">
                <slot name="actionButtons">
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
import {ChevronLeftIcon, ChevronRightIcon} from '@heroicons/vue/solid'
import { Link } from '@inertiajs/vue3';

export default {
    components: {
        ChevronLeftIcon,
        ChevronRightIcon,
        Link,
    },
    props: {
        breadcrumbs: Array,
    }
}
</script>
